import { render, staticRenderFns } from "./isModalLite.vue?vue&type=template&id=24582ffa&scoped=true&lang=html&"
import script from "./isModalLite.vue?vue&type=script&lang=js&"
export * from "./isModalLite.vue?vue&type=script&lang=js&"
import style0 from "./isModalLite.vue?vue&type=style&index=0&id=24582ffa&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24582ffa",
  null
  
)

export default component.exports